import { SvgIconProps } from '@mui/material';

const Star = ({ className }: SvgIconProps) => (
  <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path
      d="M50 0C51.139 0 52.0699 0.901929 52.1606 2.03731C54.1098 26.4318 73.5682 45.8902 97.9627 47.8394C99.0981 47.9301 100 48.861 100 50C100 51.139 99.0981 52.0699 97.9627 52.1606C73.5682 54.1098 54.1098 73.5682 52.1606 97.9627C52.0699 99.0981 51.139 100 50 100C48.861 100 47.9301 99.0981 47.8394 97.9627C45.8902 73.5682 26.4318 54.1098 2.03731 52.1606C0.90193 52.0699 0 51.139 0 50C0 48.861 0.901929 47.9301 2.03731 47.8394C26.4318 45.8902 45.8902 26.4318 47.8394 2.03731C47.9301 0.90193 48.861 0 50 0Z"
      fill="white"
    />
  </svg>
);

export default Star;
